module.exports = __webpack_public_path__ + "img/irving peddrew, 1953.83123770.jpg";